import {
  Control,
  FieldValues,
  UseFormGetValues,
  UseFormSetValue,
} from "react-hook-form";

import { IAreaPriceAdditionDto } from "@ryde/shared";

export const emptyAreaAddition: IAreaPriceAdditionDto = {
  price: "",
  areaIds: [],
  startingFromAreaIndex: "",
};

export interface IAreaAdditionItemForm {
  fieldName: string;
  control?: Control;
  index?: number;
  onEditStart?: () => void;
  onEditEnd?: () => void;
  onEdit?: () => void;
  onCancel?: () => void;
  value?: Partial<IAreaPriceAdditionDto>;
  setValue: UseFormSetValue<FieldValues>;
  getValues: UseFormGetValues<FieldValues>;
  removeHandler?: (index: number) => void;
  isNew?: boolean;
}
